module.exports.revealer = {
  vi: {
    title: 'Kẻ lộ diện (Revealer) trong Avalon: khi nào vai trò bị lộ',
    description:
      'Khi nào Kẻ lộ diện bị lộ trong Avalon? Tìm hiểu điều kiện hai Nhiệm vụ Thất bại, ai thấy vai trò và người chơi Ác còn có thể làm gì sau đó.',
    keywords: ['Kẻ lộ diện', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Revelador em Avalon: quando o papel é revelado',
    description:
      'Quando o Revelador aparece em Avalon? Duas missões fracassadas ativam a revelação pública. Entenda o que o jogador do mal ainda pode fazer.',
    keywords: ['Revelador', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Revealer in Avalon: When the Role Is Revealed',
    description:
      'When does the Revealer reveal in Avalon? Learn the two-failed-missions trigger, who sees the role and what the evil player can still do afterwards.',
    keywords: ['Revealer', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Разоблаченная в Авалоне: когда раскрывается роль',
    description:
      'Когда раскрывается Разоблаченная в Авалоне? Две проваленные миссии, видимость роли для всех и возможности злого игрока после раскрытия.',
    keywords: ['Разоблаченная', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆被揭示者：何時公開身分與後續玩法',
    description: '阿瓦隆被揭示者什麼時候現身？了解兩次任務失敗後的公開觸發條件，以及壞人被揭示後仍可採取的行動。',
    keywords: ['被揭示者', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆被揭示者：何时公开身份与后续玩法',
    description: '阿瓦隆被揭示者什么时候现身？了解两次任务失败后的公开触发条件，以及坏人被揭示后仍可采取的行动。',
    keywords: ['被揭示者', '角色', '规则', '建议'],
  },
  es: {
    title: 'Revelador en Avalon: cuándo se revela el rol',
    description:
      '¿Cuándo se revela el Revelador en Avalon? Dos misiones fallidas activan la revelación pública. Descubre qué puede hacer después el jugador malvado.',
    keywords: ['Revelada', 'Rol', 'Reglas', 'Consejos'],
  },
};
